import {
  CREATEPOSITION,
  DELETEPOSITION,
  LISTOFPERMISSIONS,
  LISTOFPOSITIONFORSELECT,
  LISTPOSITION,
  UPDATEPOSITION,
  UPDATEPOSITIONSTATUS,
  VIEWPOSITION,
} from "./ApiRoutes";
import { authData } from "./services";

export const createPosition = async (data: object) => {
  const response = await authData.post(CREATEPOSITION, data);
  return response?.data;
};
export const updatePosition = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATEPOSITION}${id}`, data);
  return response?.data;
};
export const listOfPosition = async (data: object) => {
  const response = await authData.post(LISTPOSITION, data);
  return response?.data;
};
export const viewPosition = async (id: number) => {
  const response = await authData.get(`${VIEWPOSITION}${id}`);
  return response?.data;
};
export const deletePositionApi = async (id: number) => {
  const response = await authData.delete(`${DELETEPOSITION}${id}`);
  return response?.data;
};
export const updateStatusPosition = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATEPOSITIONSTATUS}${id}`, data);
  return response?.data;
};
export const listOfPermissions = async () => {
  const response = await authData.get(LISTOFPERMISSIONS);
  return response?.data;
};
export const listOfPositionForSelectApi = async (data: object) => {
  const response = await authData.post(LISTOFPOSITIONFORSELECT, data);
  return response?.data;
};
